import type { ReactNode } from "react";

import { WholesaleCheckoutDataContext } from "@shared/context/WholesaleCheckoutDataContext";
import { useWholesalePromotionEnabled } from "@shared/hooks/useWholesalePromotionEnabled/useWholesalePromotionEnabled";

interface Props {
  children: ReactNode;
}

const WholesaleCheckoutDataProvider = ({ children }: Props) => {
  const [wholesalePromotionEnabled] = useWholesalePromotionEnabled();

  return (
    <WholesaleCheckoutDataContext
      value={{
        wholesalePromotionEnabled,
      }}
    >
      {children}
    </WholesaleCheckoutDataContext>
  );
};

export { WholesaleCheckoutDataProvider };
